import { catchError, map, Observable, of, tap } from 'rxjs';
import { ComponentDataSourceService } from '../../component-data-source.service';
import { RoomDTO } from '../../../../dto/location/room.dto';
import { Room } from '../../../../models/location/Room.model';
import { LoadDataParams } from '../../../../interfaces/DataSource/DataSourceParams.interface';
import { environment } from '../../../../environment/environment';

export function locations_rooms(componentDataSourceService: ComponentDataSourceService) {
    return {
      name: 'LocationsRooms',
      description: 'List of rooms in a specific location',
      execute: (params?: LoadDataParams) => {
        if (!params?.queryParams?.['location']) {
          return of({ items: [], totalCount: 0 });
        }else if (params?.queryParams?.['location'] == 'manual'){
          return of({ items: [], totalCount: 0 });
        }

        const locationGuid = params.queryParams['location'];

        
        return componentDataSourceService.http.get<any>(
          `${environment.apiUrl}/locations/${locationGuid}/rooms`,
          params?.queryParams ? { params: params.queryParams } : {}
        ).pipe(
          catchError(error => {
            console.error('Error fetching location rooms:', error);
            return of({ items: [], totalCount: 0 });
          }),
          map(result => {
            if (result && result.items) {
              try {
                const rooms = result.items.map((room: any) => {
                  const roomDTO: RoomDTO = {
                    guid: room.guid,
                    room_name: room.room_name + ' - ' + room.capacity + ' pladser',
                    location_guid: locationGuid,
                    capacity: room.capacity,
                    description: room.description
                  };
                  
                  return Room.fromDTO(roomDTO);
                });

                return {
                  items: rooms,
                  totalCount: result.totalCount,
                  pageSize: result.pageSize,
                  pageIndex: result.pageIndex
                };
              } catch (error) {
                console.error('Error converting DTO to Room:', error);
                return { items: [], totalCount: 0 };
              }
            } else {
              throw new Error('No rooms found for this location');
            }
          })
        );
      },
      settings: {
        columns: [
          { key: 'name', header: 'Name', type: 'text' },
          { key: 'capacity', header: 'Kapacitet', type: 'number' },
          { key: 'description', header: 'Beskrivelse', type: 'text' }
        ],
        pageable: true,
        sortable: true,
        rowHover: true,
        searchable: true,
        defaultSortColumn: 'name',
        defaultSortDirection: 'asc'
      }
    }
} 